import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useCertero } from "@/context/CerteroContext";
import { EASE } from "@/components/Reveal";
import { CONTACTO } from "@/data/content";

export default function PrivacyModal() {
  const { privacyOpen, setPrivacyOpen } = useCertero();

  return (
    <AnimatePresence>
      {privacyOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[90] flex items-end justify-center bg-ink/80 backdrop-blur-sm sm:items-center sm:p-6"
          onClick={() => setPrivacyOpen(false)}
          data-testid="privacy-modal-overlay"
        >
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.45, ease: EASE }}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] w-full max-w-lg overflow-y-auto border border-hud bg-surface p-7 sm:p-9"
            data-testid="privacy-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Política de privacidad"
          >
            <div className="flex items-start justify-between gap-4">
              <h2 className="font-display text-xl font-bold uppercase tracking-wide text-mist">
                Política de privacidad
              </h2>
              <button
                data-testid="privacy-modal-close"
                onClick={() => setPrivacyOpen(false)}
                aria-label="Cerrar"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-hud text-mist/70 transition-colors duration-300 hover:border-certero hover:text-certero"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="mt-5 flex flex-col gap-4 text-sm leading-relaxed text-smoke">
              <p>
                CERTERO SRL trata los datos que envía por los formularios de este sitio
                (nombre, teléfono, correo y mensaje) con la única finalidad de responder a su
                solicitud de cotización, servicio, soporte o información académica.
              </p>
              <p>
                Sus datos se almacenan en el sistema interno de CERTERO SRL y se envían como aviso
                a {CONTACTO.email}. No se comparten con terceros ni se utilizan para fines
                distintos del contacto comercial y técnico.
              </p>
              <p>
                Puede solicitar la actualización o eliminación de sus datos en cualquier momento
                escribiendo a {CONTACTO.email}.
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
